import { useState, useMemo, ReactNode } from 'react';
import VocalInterfaceContext from './VocalInterfaceContext';

interface VocalInterfaceProviderProps {
  children: ReactNode;
};

function VocalInterfaceProvider({ children }: VocalInterfaceProviderProps) {
  const [ currentText, setCurrentText ] = useState<string>('');
  const [ isVocalInterface, setIsVocalInterface ] = useState<boolean>(false);
  const [ isChart, setIsChart ] = useState<boolean>(false);
  const [ isAdButtonClicked, setIsAdButtonClicked ] = useState<boolean>(false);

  const vocalInterfaceContextValues = useMemo(() => ({
    currentText,
    setCurrentText,
    isVocalInterface,
    setIsVocalInterface,
    isChart,
    setIsChart,
    isAdButtonClicked,
    setIsAdButtonClicked
  }), [currentText, isVocalInterface, isChart, isAdButtonClicked]);  
  
  return (
    <VocalInterfaceContext.Provider value={ vocalInterfaceContextValues }>
      { children }
    </VocalInterfaceContext.Provider>
  );
};

export default VocalInterfaceProvider;